import {kFacebookLink} from "../../constants/links";

export default function SystemDrawerFacebookImage() {
    // Used in SystemAppDrawer to display ummia channel
    // Facebook link as a logo

    // BUILD
    return (
        <a href={kFacebookLink}
           target="_blank"
           rel="noreferrer">
            <img className="h-[32px] w-auto object-contain transition-all duration-150 hover:drop-shadow-[0_0_8px_rgba(129,153,251,0.4)] cursor-pointer"
                 src="/images/SystemFacebookLogo.png"
                 alt="Facebook"/>
        </a>
    );
}